import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-a-down-left",
  "use": "icon-a-down-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-down-left\" id=\"icon-a-down-left\"><line x1=\"17\" y1=\"7\" x2=\"7\" y2=\"17\" /><polyline points=\"17 17 7 17 7 7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol